import type { PickHistoryEntry } from '../types';

const KEY = 'flac.banast.as.pick-history.v1';

export function loadPickHistory(): PickHistoryEntry[] {
  try { const value = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(value) ? value.filter((entry): entry is PickHistoryEntry => Boolean(entry && typeof entry.albumId === 'string' && typeof entry.pickedAt === 'string')).slice(0, 100) : []; } catch { return []; }
}

function save(entries: PickHistoryEntry[]) { try { localStorage.setItem(KEY, JSON.stringify(entries.slice(0, 100))); } catch { /* Picking remains available when browser storage is blocked or full. */ } return entries.slice(0, 100); }
export function addPick(albumId: string, history: PickHistoryEntry[]) { return save([{ albumId, pickedAt: new Date().toISOString() }, ...history]); }
export function markPlayed(albumId: string, history: PickHistoryEntry[]) { return save(history.map((entry) => entry.albumId === albumId && !entry.playedAt ? { ...entry, playedAt: new Date().toISOString() } : entry)); }
export function clearPickHistory() { try { localStorage.removeItem(KEY); } catch { /* In-memory history still clears. */ } }

